import Helper from './Helper';

class Header {
  constructor(config = {}) {
    const {
      headerVideoImageSelector,
      headerVideoBlurSelector,
      mainNavSelector,
      menuTogglerSelector,
      menuContainerSelector,
      scndMenuContainerSelector,
      subMenuTogglerSelector,
      searchOpenSelector,
      searchCloseSelector,
      searchContainerSelector,
    } = config;

    this.headerVideoImage = document.querySelector(headerVideoImageSelector);
    this.headerBlur = document.querySelector(headerVideoBlurSelector);
    this.mainNav = document.querySelector(mainNavSelector);
    this.menuToggler = document.querySelector(menuTogglerSelector);
    this.menuContainer = document.querySelector(menuContainerSelector);
    this.scndMenuContainer = document.querySelector(scndMenuContainerSelector);
    this.subMenuToggler = document.querySelectorAll(subMenuTogglerSelector);
    this.subMenuTogglerArray = Array.prototype.slice.call(this.subMenuToggler);
    this.searchOpen = document.querySelector(searchOpenSelector);
    this.searchClose = document.querySelector(searchCloseSelector);
    this.searchContainer = document.querySelector(searchContainerSelector);
    this.body = document.querySelector('body');
    this.menuOpen = false;
    this.submenuOpen = false;
    this.lastSubmenuToggle;

    if(this.headerVideoImage){
      this.setImagetoBlur(this.headerVideoImage, this.headerBlur);
    }

    if(this.mainNav){
      this.bindEvents();
      this.checkIfHeaderWithImage();
    }
  }

  setImagetoBlur(imageLayer, blurLayer){
    const img = imageLayer.style.backgroundImage;
    blurLayer.style.backgroundImage = img;
  }

  bindEvents(){
    this.menuToggler.addEventListener('click', e => {
      this.toggleMenu();
    });
    this.subMenuTogglerArray.forEach((toggler, i) => {
      toggler.addEventListener('click', e => {
        e.preventDefault();
        if(Helper.hasClass(toggler, 'current-toggle')){
          this.closeSubmenus(toggler);
        } else {
          this.openSubmenu(toggler);
        }
      });
    });
    this.mainNav.addEventListener('touchstart', e => {
      this.makeHeaderWhite(true);
    });
    this.mainNav.addEventListener('touchend', e => {
      this.makeHeaderWhite(false);
    });
    this.mainNav.addEventListener('mouseenter', e => {
      this.makeHeaderWhite(true);
    });
    this.mainNav.addEventListener('mouseleave', e => {
      this.makeHeaderWhite(false);
    });
    this.searchOpen.addEventListener('click', e => {
      this.openSearch();
    });

    this.searchClose.addEventListener('click', e => {
      this.closeSearch();
    });
  }

  toggleMenu(){
    if(this.menuOpen){
      Helper.removeClass(this.menuToggler, 'burger-active');
      Helper.removeClass(this.menuContainer, 'is-open');
      Helper.removeClass(this.scndMenuContainer, 'is-open');
      Helper.removeClass(this.body, 'menu-open');
      if(document.querySelector('.menu-backdrop')){
        document.querySelector('.menu-backdrop').remove();
      }
      this.menuOpen = false;
    } else {
      Helper.addClass(this.menuToggler, 'burger-active');
      Helper.addClass(this.menuContainer, 'is-open');
      Helper.addClass(this.scndMenuContainer, 'is-open');
      Helper.addClass(this.body, 'menu-open');
      if(!document.querySelector('.menu-backdrop')){
        let backdrop = document.createElement('div');
        Helper.addClass(backdrop, 'menu-backdrop');
        this.body.appendChild(backdrop);
        backdrop.addEventListener('click', () => {
          this.toggleMenu();
        });
      }
      this.menuOpen = true;
    }
  }

  openSearch(){
    this.closeSubmenus();
    Helper.addClass(this.body, 'search-open');
    Helper.addClass(this.searchOpen, 'active');
    Helper.addClass(this.searchClose, 'active');
    Helper.addClass(this.searchContainer, 'active');
    Helper.slideDown(this.searchContainer);
    this.searchContainer.querySelector('input').focus();
  }

  closeSearch(){
    Helper.removeClass(this.body, 'search-open');
    Helper.removeClass(this.searchOpen, 'active');
    Helper.removeClass(this.searchClose, 'active');
    Helper.removeClass(this.searchContainer, 'active');
    Helper.slideUp(this.searchContainer);
  }

  closeSubmenus(toggler){
    console.log('closesubmenu');
    this.subMenuTogglerArray.forEach((toggle, i) => {
      Helper.removeClass(toggle.parentElement, 'active');
      Helper.removeClass(toggle.nextElementSibling, 'active');
      Helper.slideUp(toggle.nextElementSibling);
    });
    Helper.removeClass(this.body, 'submenu-open');
    if(document.querySelector('.menu-backdrop')){
      if(!Helper.hasClass(this.body, 'menu-open')){
        document.querySelector('.menu-backdrop').remove();
      }
    }
    if(toggler){
      Helper.removeClass(toggler, 'current-toggle');
    }
  }

  openSubmenu(toggler){
    console.log('opensubmenu');
    this.closeSearch();
    this.subMenuTogglerArray.forEach((toggle, i) => {
      if(toggle !== toggler){
        Helper.removeClass(toggle.parentElement, 'active');
        Helper.removeClass(toggle.nextElementSibling, 'active');
        Helper.slideUp(toggle.nextElementSibling);
        Helper.removeClass(this.body, 'submenu-open');
        Helper.removeClass(toggle, 'current-toggle');
        if(document.querySelector('.menu-backdrop')){
          if(!Helper.hasClass(this.body, 'menu-open')){
            document.querySelector('.menu-backdrop').remove();
          }
        }
      }
    });
    Helper.addClass(toggler.parentElement, 'active');
    Helper.addClass(toggler.nextElementSibling, 'active');
    Helper.slideDown(toggler.nextElementSibling);
    Helper.addClass(toggler, 'current-toggle');
    Helper.addClass(this.body, 'submenu-open');

    if(!document.querySelector('.menu-backdrop')){
      let backdrop = document.createElement('div');
      Helper.addClass(backdrop, 'menu-backdrop');
      this.body.appendChild(backdrop);
      backdrop.addEventListener('click', () => {
        this.closeSubmenus();
      });
    }
  }

  checkIfHeaderWithImage(){
    const nextElement = this.mainNav.nextElementSibling.firstElementChild;
    // console.log(nextElement);
    if(Helper.hasClass(nextElement, 'ns-header')){
      if(!Helper.hasClass(nextElement, 'no-image')){
        Helper.addClass(this.mainNav, 'transparent-header');
        this.makeHeaderWhite(false);
      }
    } else {
      nextElement.style.marginTop = this.mainNav.offsetHeight+'px';
    }
  }

  makeHeaderWhite(bool){
    if(bool){
      Helper.addClass(this.mainNav, 'site-header--white');
    } else {
      if(Helper.hasClass(this.mainNav, 'transparent-header')){
        Helper.removeClass(this.mainNav, 'site-header--white');
      }
    }
  }
}
export default Header;
